@if (brandsList) {
<section class="exhibitor-brands-container" #brands>
  <div class="mdc-layout-grid no-offset-x">
    <div class="mdc-layout-grid__inner">
      <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12">
        <h2 class="mat-headline-2" i18n="@@featureExhibitorDetails-pageTabExhibitor-brands">Marken</h2>
        <hr />
        <bau365-brand-card-list [brands]="brandsList" [imageZoomed]="imageZoomed"></bau365-brand-card-list>
      </div>
    </div>
  </div>
</section>
}
